import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import EditIcon from '@mui/icons-material/Edit';
import { SuccessItem, AlertItem } from "./DetailStyles";

interface StatusIndicatorProps {
    status: number;
}

const StatusIndicator = ({ status }: StatusIndicatorProps) => {
    if (status === 1) {
        return (
            <SuccessItem>
                <CheckCircleIcon sx={{ color: '#4caf50' }} />
                <span>خرید درگاه موفق</span>
            </SuccessItem>
        );
    }

    if (status === 2) {
        return (
            <AlertItem>
                <ErrorIcon sx={{ color: '#ff9800' }} />
                <span>خرید درگاه ناموفق</span>
                <EditIcon sx={{ fontSize: 18, color: '#ff9800' }} />
            </AlertItem>
        );
    }

    return null;
};

export default StatusIndicator;